"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGLineDistance = exports.getPerimerterIntersectTurfPosition = exports.getShortestIntersectPosition = exports.getShortestIntersectTurfPosition = exports.getIGeofenceCenterTurf = exports.positionArrayToBBox = exports.geoObjectsToTurfPosition = exports.geoObjectsToTurfFeatures = exports.positionArrayToTurfPolyline = exports.positionArrayToTurfPolygon = exports.turfPolygonToPositionArray = exports.extendPositionToCirclishPolygon = exports.latLngPositionToRads = exports.positionRadsToLatLng = exports.getRandomPointOutsidePoints = exports.getRandomPointInPoints = exports.extendPointToPoints = exports.extendPointToBounds = exports.turfBBoxToPoints = exports.convertPointToTurfPosition = exports.getThingInArea = exports.tPositionIsInPoints = exports.gPositionIsInGPoints = exports.isInArea = exports.convertTurfPointsToGLatLng = exports.tPositionToGPoint = exports.gPointToTPosition = exports.gPointsToTClosedPosition = exports.convertTPositionToGPoints = exports.convertGPointsToTPosition = exports.convertGLatLngToPosition = void 0;
exports.isValidGPosition = isValidGPosition;
exports.isValidGPositionSet = isValidGPositionSet;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const boolean_point_in_polygon_1 = require("@turf/boolean-point-in-polygon");
const helpers_1 = require("@turf/helpers");
const destination_1 = require("@turf/destination");
const turf_1 = require("@turf/turf");
const bbox_1 = require("@turf/bbox");
const center_1 = require("@turf/center");
const line_intersect_1 = require("@turf/line-intersect");
const point_to_line_distance_1 = require("@turf/point-to-line-distance");
const nearest_point_on_line_1 = require("@turf/nearest-point-on-line");
const random_1 = require("@turf/random");
const objectMatching_1 = require("../objects/objectMatching");
const core_services_1 = require("@iotv/core-services");
const distance_1 = require("@turf/distance");
const debug = process.env.REACT_APP_DEBUG && false;
const convertGLatLngToPosition = (geofence) => {
    const pointsArrayMap = geofence.points;
    const pointsArrayArray = [];
    if (pointsArrayMap)
        pointsArrayMap.map((pointMap) => pointsArrayArray.push([pointMap.lat, pointMap.lng]));
    return pointsArrayArray;
};
exports.convertGLatLngToPosition = convertGLatLngToPosition;
const convertGPointsToTPosition = (points) => {
    const pointsArrayArray = [];
    points.forEach((pointMap) => pointsArrayArray.push((0, exports.gPointToTPosition)(pointMap)));
    return pointsArrayArray;
};
exports.convertGPointsToTPosition = convertGPointsToTPosition;
const convertTPositionToGPoints = (points) => {
    const pointsArrayArray = [];
    points.forEach((pointMap) => pointsArrayArray.push((0, exports.tPositionToGPoint)(pointMap)));
    return pointsArrayArray;
};
exports.convertTPositionToGPoints = convertTPositionToGPoints;
/** for polygon wher first must equal last  */
const gPointsToTClosedPosition = (points) => {
    const clonedPts = [...points];
    const p0 = clonedPts[0];
    const pN = clonedPts[clonedPts.length - 1];
    if (!(0, objectMatching_1.objectsMatch)(p0, pN)) {
        clonedPts.push(p0);
    }
    return clonedPts;
};
exports.gPointsToTClosedPosition = gPointsToTClosedPosition;
const gPointToTPosition = (point) => [point.lng, point.lat];
exports.gPointToTPosition = gPointToTPosition;
const tPositionToGPoint = (position) => (0, exports.convertTurfPointsToGLatLng)(position);
exports.tPositionToGPoint = tPositionToGPoint;
const convertTurfPointsToGLatLng = ([lng, lat]) => {
    return { lat: lat, lng: lng };
};
exports.convertTurfPointsToGLatLng = convertTurfPointsToGLatLng;
//position must be [latNum, lonNum]
const isInArea = (position, geofence) => {
    debug && console.log('is in Area with: ', [position, geofence]);
    let isInArea = false;
    if (geofence === undefined || geofence.points === undefined) {
        console.log('Geofence undefined');
    }
    else {
        isInArea = (0, exports.tPositionIsInPoints)(position, geofence.points);
    }
    return isInArea;
};
exports.isInArea = isInArea;
const gPositionIsInGPoints = (position, points) => {
    const tPosition = (0, exports.gPointToTPosition)(position);
    return (0, exports.tPositionIsInPoints)(tPosition, points);
};
exports.gPositionIsInGPoints = gPositionIsInGPoints;
const tPositionIsInPoints = (position, points) => {
    const turfPoint = (0, helpers_1.point)(position);
    const turfPoly = (0, exports.positionArrayToTurfPolygon)(points);
    const isInArea = (0, boolean_point_in_polygon_1.booleanPointInPolygon)(turfPoint, turfPoly);
    return isInArea;
};
exports.tPositionIsInPoints = tPositionIsInPoints;
/* Defined in UI version of Turf Utils */
const getThingInArea = (userView, pointArr) => undefined;
exports.getThingInArea = getThingInArea;
const convertPointToTurfPosition = (position) => undefined;
exports.convertPointToTurfPosition = convertPointToTurfPosition;
function isValidGPosition(gPos) {
    const keys = gPos ? Object.keys(gPos) : [];
    return (keys.includes('lat') &&
        keys.includes('lng') &&
        typeof gPos?.lat === 'number' &&
        typeof gPos?.lng === 'number' &&
        gPos.lat >= -90 &&
        gPos.lat <= 90 &&
        gPos.lng >= -180 &&
        gPos.lng <= 180);
}
function isValidGPositionSet(gPosArr) {
    let clone = [...gPosArr];
    let isValid = true;
    clone.unshift(isValid);
    const testRes = clone.reduce((valid, next) => valid === true && isValidGPosition(next));
    console.log(`Geofence test result is ${testRes} for`, gPosArr);
    return testRes;
}
/** [sw, nw, ne, se] in {lat lng}s  */
const turfBBoxToPoints = (bbx) => {
    const sw = (0, exports.convertTurfPointsToGLatLng)(bbx.slice(0, 2));
    const ne = (0, exports.convertTurfPointsToGLatLng)(bbx.slice(2, 4));
    const nw = { lat: ne.lat, lng: sw.lng };
    const se = { lat: sw.lat, lng: ne.lng };
    return [sw, nw, ne, se];
};
exports.turfBBoxToPoints = turfBBoxToPoints;
/** given a position and distance in meters to extend north easterly returns Google like Bounds */
const extendPointToBounds = (pt, metersDiag = 10) => {
    const pointA = (0, helpers_1.point)([pt.lng, pt.lat]);
    const pointB = (0, destination_1.destination)(pointA, metersDiag, 45, { units: 'meters' });
    const bbx = (0, bbox_1.bbox)((0, helpers_1.featureCollection)([pointA, pointB]));
    const sw = (0, exports.convertTurfPointsToGLatLng)(bbx.slice(0, 2));
    const ne = (0, exports.convertTurfPointsToGLatLng)(bbx.slice(2, 4));
    return { sw, ne };
};
exports.extendPointToBounds = extendPointToBounds;
/** given a position and distance in meters to extend north easterly returns an set of points ( bbx ) [sw, nw, ne, se] */
const extendPointToPoints = (pt, metersDiag) => {
    const pointA = (0, helpers_1.point)([pt.lng, pt.lat]);
    const pointB = (0, destination_1.destination)(pointA, metersDiag, 45, { units: 'meters' });
    const bbx = (0, bbox_1.bbox)((0, helpers_1.featureCollection)([pointA, pointB]));
    return (0, exports.turfBBoxToPoints)(bbx);
};
exports.extendPointToPoints = extendPointToPoints;
const getRandomPointInPoints = (points) => {
    const tBounds = (0, exports.convertGPointsToTPosition)(points);
    const tBBox = (0, bbox_1.bbox)((0, helpers_1.featureCollection)(tBounds.map((tPos) => (0, helpers_1.point)(tPos))));
    const pt = (0, random_1.randomPosition)(tBBox);
    return (0, exports.convertTurfPointsToGLatLng)(pt);
};
exports.getRandomPointInPoints = getRandomPointInPoints;
const getRandomPointOutsidePoints = (points) => {
    const getRandomPt = () => (0, random_1.randomPoint)(1).features[0].geometry.coordinates;
    let outsidePt = undefined;
    while (!outsidePt || (0, exports.tPositionIsInPoints)(outsidePt, points)) {
        outsidePt = getRandomPt();
    }
    return (0, exports.tPositionToGPoint)(outsidePt);
};
exports.getRandomPointOutsidePoints = getRandomPointOutsidePoints;
const radiansToDegrees = (radians) => radians * (180 / Math.PI);
const degreesToRadians = (degrees) => (Math.PI / 180) * degrees;
const positionRadsToLatLng = ({ lat, lng }) => ({ lat: radiansToDegrees(lat), lng: radiansToDegrees(lng) });
exports.positionRadsToLatLng = positionRadsToLatLng;
const latLngPositionToRads = ({ lat, lng }) => ({ lat: degreesToRadians(lat), lng: degreesToRadians(lng) });
exports.latLngPositionToRads = latLngPositionToRads;
/** polygon aroudn a Position ( { lat, lng } ), that can be a square when steps in 4, based on circle with centre position with radius radialDistance units, default units is meters */
const extendPositionToCirclishPolygon = ({ position, steps, radialDistance, units = 'metres', properties }) => {
    var center = [position.lng, position.lat];
    var radius = radialDistance;
    var options = { steps, units, properties };
    return (0, turf_1.circle)(center, radius, options);
};
exports.extendPositionToCirclishPolygon = extendPositionToCirclishPolygon;
const turfPolygonToPositionArray = (turfPolygon) => {
    const positionArray = turfPolygon.coordinates[0].map(exports.convertTurfPointsToGLatLng);
    return positionArray;
};
exports.turfPolygonToPositionArray = turfPolygonToPositionArray;
const positionArrayToTurfPolygon = (points) => {
    const areaAsArrays = (0, exports.convertGPointsToTPosition)((0, exports.gPointsToTClosedPosition)(points));
    var turfPoly = (0, helpers_1.polygon)([areaAsArrays]); //seems to require array of arrays
    return turfPoly;
};
exports.positionArrayToTurfPolygon = positionArrayToTurfPolygon;
const positionArrayToTurfPolyline = (points) => {
    const areaAsArrays = (0, exports.convertGPointsToTPosition)((0, exports.gPointsToTClosedPosition)(points));
    var turfLine = (0, helpers_1.multiLineString)([areaAsArrays]); //seems to require array of arrays
    return turfLine;
};
exports.positionArrayToTurfPolyline = positionArrayToTurfPolyline;
const geoObjectsToTurfFeatures = (geoObjects) => geoObjects
    .filter((g) => (0, iotv_v3_types_1.isPosition)(g.location) || (0, iotv_v3_types_1.isIGeofence)(g))
    .map((g) => {
    if (!!g.points) {
        return (0, exports.positionArrayToTurfPolygon)(g.points);
    }
    else if ((0, iotv_v3_types_1.isPosition)(g.location)) {
        return (0, helpers_1.point)((0, exports.gPointToTPosition)(g.location));
    }
    else {
        return null;
    }
})
    .filter(core_services_1.existsFilter);
exports.geoObjectsToTurfFeatures = geoObjectsToTurfFeatures;
const geoObjectsToTurfPosition = (geoObjects) => geoObjects
    .filter((g) => (0, iotv_v3_types_1.isPosition)(g.location) || (0, iotv_v3_types_1.isIGeofence)(g))
    .map((g) => {
    if (g.points) {
        return g.points.map(exports.gPointToTPosition);
    }
    else {
        return [(0, exports.gPointToTPosition)(g.location)];
    }
})
    .flat();
exports.geoObjectsToTurfPosition = geoObjectsToTurfPosition;
/** returns bbox of position array, using turf bbox: extent in minX, minY, maxX, maxY order, which is sw, ne */
const positionArrayToBBox = (positionArray) => {
    const positionArrayTurf = (0, exports.convertGPointsToTPosition)(positionArray);
    const tBBox = (0, bbox_1.bbox)((0, helpers_1.featureCollection)(positionArrayTurf.map((tPos) => (0, helpers_1.point)(tPos))));
    const bboxIotv = { sw: { lat: tBBox[1], lng: tBBox[0] }, ne: { lat: tBBox[3], lng: tBBox[2] } };
    return bboxIotv;
};
exports.positionArrayToBBox = positionArrayToBBox;
/** returns the centre IN TURF POSTITION of an IGeofence */
const getIGeofenceCenterTurf = (geofence) => {
    const pArray = geofence.points.filter(({ lat, lng }) => (0, iotv_v3_types_1.isNonNaNNumber)(lat) && (0, iotv_v3_types_1.isNonNaNNumber)(lng)).map(({ lat, lng }) => [lng, lat]);
    const xCenter = (0, center_1.center)((0, helpers_1.points)(pArray)).geometry.coordinates;
    return xCenter;
};
exports.getIGeofenceCenterTurf = getIGeofenceCenterTurf;
/** returns nearest TurfPosition as NearestPointOnLine ( a Feature ) on edges of polygon to given position - used to draw rays that dont converge on the position
 * If the position is not outside the polygon the returned value will be undefined, and consumers should use the original position
 */
const getShortestIntersectTurfPosition = (position, geofence) => {
    const tPos = (0, exports.gPointToTPosition)(position);
    const areaAsArrays = (0, exports.convertGPointsToTPosition)((0, exports.gPointsToTClosedPosition)(geofence.points));
    const turfPoly = (0, helpers_1.polygon)([areaAsArrays]); //seems to require array of arrays
    const turfPolyLines = (0, helpers_1.lineString)(turfPoly.geometry.coordinates[0]);
    // const geofenceEdges: TurfPosition[][] = turfPoly.geometry.coordinates[0].map( ( tPos, i) => [ tPos, turfPoly.geometry.coordinates[0][i + 1 ]]).filter( ( [ p1, p2 ]) => p1 && p2)
    // const turfLines: Feature<LineString, GeoJsonProperties>[] = geofenceEdges.map( ( edgeCoords ) =>  lineString( edgeCoords ))
    // const distanceToTurfLines: LineDistance[] = turfLines.map( ( line ) => ({ turfLine: line, distanceKm: pointToLineDistance( tPos, line, { units: 'kilometers'} )}))
    // const nearesLineDistance: LineDistance = distanceToTurfLines.reduce( ( a, c ) => c.distanceKm < a.distanceKm ? c : a  )
    const nearestPointOnline = (0, nearest_point_on_line_1.nearestPointOnLine)(turfPolyLines, tPos);
    return nearestPointOnline;
};
exports.getShortestIntersectTurfPosition = getShortestIntersectTurfPosition;
const getShortestIntersectPosition = (position, geofence) => {
    const nearestPointOnLine = (0, exports.getShortestIntersectTurfPosition)(position, geofence);
    const intersectPosition = (0, exports.tPositionToGPoint)(nearestPointOnLine.geometry.coordinates);
    return intersectPosition;
};
exports.getShortestIntersectPosition = getShortestIntersectPosition;
const getPerimerterIntersectTurfPosition = (position, geofence) => {
    const tPos = (0, exports.gPointToTPosition)(position);
    const areaAsArrays = (0, exports.convertGPointsToTPosition)((0, exports.gPointsToTClosedPosition)(geofence.points));
    const turfPoly = (0, helpers_1.polygon)([areaAsArrays]); //seems to require array of arrays
    const geofenceCenter = (0, center_1.center)(turfPoly);
    const geofenceCenterTPosition = geofenceCenter.geometry.coordinates;
    const positionToGeofenceLine = (0, helpers_1.lineString)([tPos, geofenceCenterTPosition]);
    const geofenceEdges = turfPoly.geometry.coordinates[0]
        .map((tPos, i) => [tPos, turfPoly.geometry.coordinates[0][i + 1]])
        .filter(([p1, p2]) => p1 && p2);
    const turfLines = geofenceEdges.map((edgeCoords) => (0, helpers_1.lineString)(edgeCoords));
    const distanceToTurfLines = turfLines.map((line) => ({
        turfLine: line,
        distanceKm: (0, point_to_line_distance_1.pointToLineDistance)(tPos, line, { units: 'kilometers' }),
    }));
    const nearesLineDistance = distanceToTurfLines.reduce((a, c) => (c.distanceKm < a.distanceKm ? c : a));
    const nearestEdge = nearesLineDistance.turfLine;
    const intersectionPoint = (0, line_intersect_1.lineIntersect)(turfPoly, positionToGeofenceLine);
    const intersectionPointTurfPosition = intersectionPoint.features?.[0]?.geometry?.coordinates;
    const intersectPosition = intersectionPointTurfPosition && (0, exports.tPositionToGPoint)(intersectionPointTurfPosition);
    return intersectPosition;
};
exports.getPerimerterIntersectTurfPosition = getPerimerterIntersectTurfPosition;
const getGLineDistance = (start, end, units) => {
    const tStart = (0, exports.gPointToTPosition)(start);
    const tEnd = (0, exports.gPointToTPosition)(end);
    const distanceBetweenPoints = (0, distance_1.distance)(tStart, tEnd, { units });
    return distanceBetweenPoints;
};
exports.getGLineDistance = getGLineDistance;
